import { defineMessages } from 'react-intl';

export default defineMessages({
    typeOfChanges: {
        id: 'tdic.endorsement.common.view.Type of Changes',
        defaultMessage: 'Type of Changes'
    },
    policyChangeEfectiveDate: {
        id: 'tdic.endorsement.common.view.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    selectTypeOfChanges: {
        id: 'tdic.endorsement.common.view.Select Type of Changes',
        defaultMessage: 'Select Type of Changes'
    },
    typeProfileChanges: {
        id: 'tdic.endorsement.pl.directives.templates.pl-profile.Profile Changes',
        defaultMessage: 'Profile Changes'
    },
    typeMailingAddress: {
        id: 'tdic.endorsement.pl.directives.templates.pl-mailing.Mailing Address',
        defaultMessage: 'Mailing Address'
    },
    typePaperlessPreference: {
        id: 'tdic.endorsement.pl.directives.templates.pl-paperless.Paperless Preference',
        defaultMessage: 'Paperless Preference'
    },
    typeDBLAI: {
        id: 'tdic.endorsement.pl.directives.templates.pl-dblai.Dental Business Liability Additional Insured',
        defaultMessage: 'Dental Business Liability Additional Insured'
    },
    typeOfChangeText: {
        id: 'tdic.endorsement.common.view.Please select the type of change and confirm the effective date below. The mailing address change is for policy correspondence only and not for a change in insured location. The effective date indicates the date as of which you are requesting the change to be made.',
        defaultMessage: 'Please select the type of change and confirm the effective date below. The mailing address change is for policy correspondence only and not for a change in insured location. The effective date indicates the date as of which you are requesting the change to be made.'
    },
    CanNotLoadYourPolicyAtThisTime: {
        id: 'tdic.endorsement.pl.directives.templates.pl-profile.Sorry we can not load your policy information at this time',
        defaultMessage: 'Sorry we can not load your policy information at this time'
    },
    policyRequestFailed: {
        id: 'tdic.endorsement.pl.directives.templates.pl-profile.ERROR',
        defaultMessage: 'ERROR'
    }
});
